import React from 'react';
import { Link } from 'react-router-dom';
import { RotateCcw, ArrowLeft, CheckCircle2 } from 'lucide-react';
import { Button } from '../components/ui/button';

export const ReturnsPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-rose-50/50 to-white">
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="text-2xl font-bold text-[#7d1f3d]">
              CurveeForYou
            </Link>
            <Link to="/">
              <Button variant="outline" className="border-[#7d1f3d] text-[#7d1f3d] hover:bg-[#7d1f3d] hover:text-white">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Shop
              </Button>
            </Link>
          </div>
        </div>
      </header>

      <main className="container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-5xl font-bold text-[#7d1f3d] mb-6">Returns & Guarantee</h1>
        <p className="text-xl text-gray-600 mb-12">Love it or your money back</p>

        <div className="space-y-8">
          <div className="bg-gradient-to-br from-[#7d1f3d] to-[#9d2f4d] text-white rounded-2xl p-8">
            <div className="flex items-center gap-4 mb-4">
              <CheckCircle2 className="w-12 h-12" />
              <h2 className="text-3xl font-bold">30-Day Satisfaction Guarantee</h2>
            </div>
            <p className="text-lg opacity-90">
              We stand behind the quality of our Faja Colombiana. If you&apos;re not completely satisfied with your purchase, return it within 30 days for a full refund.
            </p>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <h2 className="text-2xl font-bold text-[#7d1f3d] mb-4">How to Return Your Order</h2>
            <ol className="space-y-4 text-gray-600">
              <li className="flex gap-3">
                <span className="font-bold text-[#7d1f3d] flex-shrink-0">1.</span>
                <span>Contact our customer service at info@curveeforyou.com within 30 days of receiving your order</span>
              </li>
              <li className="flex gap-3">
                <span className="font-bold text-[#7d1f3d] flex-shrink-0">2.</span>
                <span>Include your order number and reason for return</span>
              </li>
              <li className="flex gap-3">
                <span className="font-bold text-[#7d1f3d] flex-shrink-0">3.</span>
                <span>We&apos;ll provide you with return shipping instructions</span>
              </li>
              <li className="flex gap-3">
                <span className="font-bold text-[#7d1f3d] flex-shrink-0">4.</span>
                <span>Once we receive your return, we&apos;ll process your refund within 5-7 business days</span>
              </li>
            </ol>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <h2 className="text-2xl font-bold text-[#7d1f3d] mb-4">Return Policy Details</h2>
            <ul className="space-y-3 text-gray-600">
              <li className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                <span>Items must be unused, unwashed, and in original packaging</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                <span>Returns must be initiated within 30 days of delivery</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                <span>Refunds are issued to the original payment method</span>
              </li>
              <li className="flex items-start gap-2">
                <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-1" />
                <span>Customer is responsible for return shipping costs unless item is defective</span>
              </li>
            </ul>
          </div>

          <div className="bg-white border-2 border-gray-100 rounded-xl p-8 shadow-md">
            <h2 className="text-2xl font-bold text-[#7d1f3d] mb-4">Exchanges</h2>
            <p className="text-gray-600 leading-relaxed">
              Need a different size or color? Contact us at info@curveeforyou.com and we&apos;ll help you with an exchange. We want you to love your faja!
            </p>
          </div>
        </div>
      </main>

      <footer className="bg-[#7d1f3d] text-white py-8 mt-16">
        <div className="container mx-auto px-6 text-center">
          <div className="flex flex-wrap justify-center gap-6 mb-4">
            <Link to="/faq" className="hover:text-[#d4af37] transition-colors">FAQ</Link>
            <Link to="/shipping" className="hover:text-[#d4af37] transition-colors">Shipping</Link>
            <Link to="/returns" className="hover:text-[#d4af37] transition-colors">Returns</Link>
            <Link to="/size-guide" className="hover:text-[#d4af37] transition-colors">Size Guide</Link>
            <Link to="/contact" className="hover:text-[#d4af37] transition-colors">Contact</Link>
          </div>
          <div className="text-sm opacity-90 mb-3 leading-relaxed">
            <p className="font-semibold mb-1">CurveeForYou</p>
            <p>1209 Mountain Road Place Northeast, Suite N</p>
            <p>Albuquerque, NM 87110, United States</p>
            <p className="mt-2">
              <a href="tel:+18002985173" className="hover:text-[#d4af37] transition-colors">Tel: 800 298 5173</a>
              {' · '}
              <a href="mailto:info@curveeforyou.com" className="hover:text-[#d4af37] transition-colors">info@curveeforyou.com</a>
            </p>
          </div>
          <p className="text-sm opacity-80">© 2025 CurveeForYou. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};